import React, { createRef } from "react";
import I18n from "i18n-js";
import { bool, func } from "prop-types";
import Modal from "../../common/components/elements/Modal";
import PreviewableDocument from "../../common/components/form/PreviewableDocument";
import TextInput from "../../common/components/form/TextInput";
import LabelDateInput from "../../common/components/form/LabelDateInput";
import SubmitButton from "../../common/components/form/SubmitButton";
import Form from "../../common/components/form/Form";
import parseDateFromDDMMYYYY from "../utils/parseDateFromDDMMYYYY";

class FormModalAddCertificate extends Form {
  static propTypes = {
    isOpen: bool.isRequired,
    onClose: func.isRequired,
    createCertificate: func.isRequired,
  };

  constructor(props) {
    super(props);

    this.inputs.certificate = createRef();
    this.inputs.certificateNumber = createRef();
    this.inputs.certificateStartDate = createRef();
    this.inputs.certificateEndDate = createRef();
    this.errors = {};

    this.onSubmit = this.onSubmit.bind(this);
  }

  /**
   * {@inheritdoc}
   */
  componentDidUpdate(prevProps) {
    const { errors } = this.props;

    if (prevProps.errors === errors) {
      return;
    }

    if (errors) {
      this.setState({ errors });
    }
  }

  isFormValid(data) {
    Object.keys(data).map((key) => {
      if (data[key] === null || data[key] === "") {
        this.errors[key] = "Champs obligatoire";
      } else {
        delete this.errors[key];
      }
    });
    this.setState({ errors: this.errors });
    if (Object.keys(this.errors).length > 0) {
      return false;
    }

    const startDate = parseDateFromDDMMYYYY(
      this.getInputValue("certificateStartDate")
    );
    const endDate = parseDateFromDDMMYYYY(
      this.getInputValue("certificateEndDate")
    );

    if (startDate && endDate && startDate > endDate) {
      this.errors.certificateStartDate = I18n.t(
        "pages.clients.certificates.create.form.certificateStartDate:error:beforeEndDate"
      );
      return false;
    }

    return true;
  }

  onSubmit() {
    const data = {
      certificate: this.getInputValue("certificate"),
      certificateNumber: this.getInputValue("certificateNumber"),
      certificateStartDate: this.getInputValue("certificateStartDate"),
      certificateEndDate: this.getInputValue("certificateEndDate"),
    };

    if (!this.isFormValid(data)) {
      return;
    }

    this.props.createCertificate(data);
    this.props.onClose();
  }

  render() {
    const { isOpen, onClose, isLoading } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        title={I18n.t("pages.clients.certificates.create.title")}
        onClose={onClose}
      >
        <form>
          <h2 className="text-center">
            {I18n.t("pages.clients.certificates.create.title")}
          </h2>
          <PreviewableDocument
            id="enterpriseCertificate"
            label={I18n.t(
              "pages.clients.certificates.create.form.certificate:label"
            )}
            ref={this.inputs.certificate}
            accept={[".pdf"]}
            defaultValue={null}
            error={this.errors.certificate}
            optional
            inline
          />
          <TextInput
            id="certificateNumber"
            label={I18n.t(
              "pages.clients.certificates.create.form.certificateNumber:label"
            )}
            ref={this.inputs.certificateNumber}
            error={this.errors.certificateNumber}
            optional
          />
          <LabelDateInput
            id="certificateStartDate"
            forwardedRef={this.inputs.certificateStartDate}
            error={this.errors.certificateStartDate}
            label={I18n.t(
              "pages.clients.certificates.create.form.certificateStartDate:label"
            )}
            optional
          />
          <LabelDateInput
            id="certificateEndDate"
            forwardedRef={this.inputs.certificateEndDate}
            error={this.errors.certificateEndDate}
            label={I18n.t(
              "pages.clients.certificates.create.form.certificateEndDate:label"
            )}
            optional
          />
          <SubmitButton loading={isLoading} onClick={this.onSubmit} />
        </form>
      </Modal>
    );
  }
}

export default FormModalAddCertificate;
